import React, { useState, useEffect, useCallback } from "react";
import { FaBackspace } from "react-icons/fa";
import { toast } from "react-toastify";
import { useQuery } from "@tanstack/react-query";
import { useNavigate, useLocation } from "react-router-dom";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {
  CheckCircle,
  Pending,
  Schedule,
  InfoOutlined,
  AccessTime,
  Autorenew,
} from "@mui/icons-material";
import CountertopsIcon from "@mui/icons-material/Countertops";

import {
  GetToken,
  GetTokenCall,
  GetHoldToken,
  CompleteTokenStatus,
  TokenTransfer,
  GetAllPendingToken,
  GetDepartments,
  GetRecallToken,
  CheckTokenValue,
  HoldTokenStatus,
  GetSevice,
  GetCompleted,
  GetTimeline,
  GetUserByToken,
  GetDepartmentCounter,
  GetDepartmentForCoordinator,
} from "../../../lib/api";

import { TokenReset } from "./TokenReset";
import PendingToken from "./PendingToken";
import TokenCall from "./TokenCallPopUp";
import Cookies from "js-cookie";
import { useParams } from "react-router-dom";
import {
  Badge,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Box,
  DialogTitle,
  Typography,
  CircularProgress,
} from "@mui/material";
import CompletedToken from "./CompletedToken";

const Counter = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const [depPrefix, setDepPrefix] = useState("");
  const [tokenValue, setTokenValue] = useState("");
  

  const [departmentID, setDepartmentID] = useState("");
  const [tokenID, setTokenID] = useState("");
  const [serviceID, setServiceId] = useState("");
  const [isRecallButtonDisabled, setIsRecallButtonDisabled] = useState(false);
  const [isLoadingCall, setIsLoadingCall] = useState(false);
  const [holdMenu, setHoldMenu] = useState(false);
  const [pollingEnabled, setPollingEnabled] = useState(false);
  const [completedMenu, setCompletedMenu] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [openPrefixPopUp, setOpenPrefixPopUp] = React.useState(false);
  const isCounterData = location?.state?.userCounterData;
  const CounterID = Cookies.get("CounterID");
  const [selectedServiceId, setSelectedServiceId] = useState("");
  const [popupData, setPopupData] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [checkPrefix, setCheckPrefix] = useState(false);
  const [timelineLoading, setTimelineLoading] = useState(false);
  const [currentCookieDepID, setCurrentCookieDepartmentID] = useState("");
  const [currentCounterID, setCurrentCounterID] = useState(null);
  const [showDepartmentWarning, setShowDepartmentWarning] = useState(false);
  const [recallTimer, setRecallTimer] = useState();

  useEffect(() => {
    try {
      const stored = localStorage.getItem("CurrentCounter");
      if (stored) {
        const parsed = JSON.parse(stored);

        setCurrentCounterID(parsed?.CounterID);

        if (parsed?.DepId) {
          Cookies.set("DepId", parsed.DepId.toString(), { path: "/" });
        }

        if (parsed?.DepPrefix) {
          Cookies.set("DepPrefix", parsed.DepPrefix.toString(), { path: "/" });
        }

        if (parsed?.CounterID) {
          Cookies.set("CounterID", parsed.CounterID.toString(), { path: "/" });
        }
      }
    } catch (error) {
      console.error("Error parsing CurrentCounter from localStorage:", error);
    }
  }, []);

  useEffect(() => {
    const isCustomCall = Cookies.get("isCustomCall");
    const counterId = Cookies.get("CounterID");

    if (isCustomCall === "true" && counterId) {
      navigate(`/custom-counter/${counterId}`);
    }
  }, [navigate]);

  const { data: service } = useQuery({
    queryKey: ["GetSevice"],
    queryFn: () => GetSevice(),
    refetchInterval: 5000,
    staleTime: 30000,
  });

  const { data: CounterData } = useQuery({
    queryKey: ["GetDepartmentCounter"],
    queryFn: () => GetDepartmentCounter(departmentID),
    refetchInterval: !pollingEnabled ? 1000 : false,
    enabled: !pollingEnabled && !!departmentID,
  });

// const resetToken = Cookies.get("resetToken");

// console.log("Reset Token:",  resetToken);

  const { isLoading, data, refetch } = useQuery({
    queryKey: ["GetToken"],
    queryFn: () => GetToken(CounterID),
    refetchInterval: 2000,
    keepPreviousData: true,
  });
  

  const nextToken = data?.data?.tokenValues?.NextToken;
  const prefix = nextToken ? nextToken.split("-")[0] : null;
  // console.log(prefix);

  const counterOnCallToken =
    data?.data?.tokenValues?.LatestCounterCallToken?.[0] ?? null;

  // console.log(counterOnCallToken?.DepName, "counterOnCallToken");

  const cookieCounterID = currentCounterID || Number(Cookies.get("CounterID"));
  const counterList = data?.data?.tokenValues?.LatestCounterCallToken || [];
  //  console.log(counterList,"counterList");
   
  
  const currentCounterToken =
    counterList.find(
      (counter) => Number(counter.CounterID) === Number(cookieCounterID),
    ) || null;

  // console.log(currentCounterToken, "currentCounterToken");
//  console.log("cookieCounterID:", cookieCounterID, typeof cookieCounterID)
 
  const latestOnCallTokens =
    counterList.find(
      (counter) => Number(counter.CounterID) === Number(cookieCounterID),
    ) || null;

  // console.log(latestOnCallTokens, "latestOnCallTokens");

  useEffect(() => {
    try {
      const stored = localStorage.getItem("CurrentCounter");
      if (stored) {
        const parsed = JSON.parse(stored);

        // Validate data
        if (!parsed?.counter) return;

        const { counter, DepPrefix } = parsed;

        // Update state
        if (counter?.CounterID) {
          setCurrentCounterID(counter.CounterID);
        }

        // Always set cookies based on localStorage data
        // This ensures cookies are never undefined when localStorage has data

        // Set DepId from counter.DepID
        if (counter?.DepID) {
          Cookies.set("DepId", counter.DepID.toString(), { path: "/" });
        }

        // Set DepPrefix (prioritize root DepPrefix, fallback to counter.DepPrefix)
        const finalDepPrefix = DepPrefix || counter?.DepPrefix || "";
        Cookies.set("DepPrefix", finalDepPrefix.toString(), { path: "/" });

        // Set CounterID from counter.CounterID
        if (counter?.CounterID) {
          Cookies.set("CounterID", counter.CounterID.toString(), { path: "/" });
        }

        // Optional: Set TokenID if needed
        if (counter?.TokenID) {
          Cookies.set("TokenID", counter.TokenID.toString(), { path: "/" });
        }
      }
    } catch (error) {
      console.error("Error parsing CurrentCounter:", error);
    }
  }, []);

  const CounterOnCallServiceID =
    data?.data?.tokenValues?.LatestCounterCallToken?.[0]?.ServiceID || 0;

  const handleButtonClick = (digit) => {
    const newTokenValue =
      tokenValue === "0" ? digit.toString() : tokenValue + digit.toString();
    // const ServiceID =
    setTokenValue(newTokenValue);
    setDepPrefix(Cookies.get("DepPrefix"));
    setCurrentCookieDepartmentID(Cookies.get("DepId"));
  };

  const { data: holdToken } = useQuery({
    queryKey: ["GetHoldToken"],
    queryFn: () => GetHoldToken(),
    refetchInterval: !pollingEnabled ? 1000 : false,
    enabled: !pollingEnabled,
  });

  const filteredTokens = holdToken?.data?.tokensOnHold.filter((token) => {
    if (!selectedServiceId) return true;
    const serviceId = Number(selectedServiceId);
    return token.ServiceID === serviceId;
  });

  const evenTokens = filteredTokens?.filter((item, index) => index % 2 === 0);
  const oddTokens = filteredTokens?.filter((item, index) => index % 2 === 1);

  const CounterButton = ({ num }) => {
    return (
      <button
        className="flex items-center justify-center p-4 font-bold shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] w-50 h-50 bg-gray-100 text-center leading-50 text-base text-gray-700 m-1"
        onClick={() => handleButtonClick(num)}
      >
        {num}
      </button>
    );
  };

  const completedTokenValueIs = counterOnCallToken?.LastOnCallToken;
  const completedTokenDeprefix = counterOnCallToken?.DepPrefix;

  const handleTokenComplete = useCallback(async () => {
    if (isLoadingCall) return;
    if (!completedTokenDeprefix) {
      toast.info("Department Prefix is missing", {
        position: "top-right",
        closeOnClick: true,
      });
      return;
    }
    setIsLoadingCall(true);
    try {
      const getCurrentToken = await CompleteTokenStatus(
        completedTokenValueIs,
        completedTokenDeprefix,
      );
      if (getCurrentToken.status === 200) {
        toast.success("Token Completed", {
          position: "top-right",
          closeOnClick: true,
        });
        setTokenValue("");
        setDepPrefix("");
      } else {
        toast.error("Token Completion failed", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      toast.error(error.response.data.message || "Token Completion Failed", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setIsLoadingCall(false);
      setOpen(false);
      Cookies.set("isHoldToken", false);
      refetch();
    }
    refetch();
    Cookies.set("isHoldToken", false);
  }, [completedTokenValueIs, completedTokenDeprefix]);

  const handleHoldCurrentToken = async () => {
    if (isLoadingCall) return;

    const currentToken =
      latestOnCallTokens?.LastOnCallToken ||
      counterOnCallToken?.LastOnCallToken;
    const currentDepPrefix =
      latestOnCallTokens?.DepPrefix || counterOnCallToken?.DepPrefix;

    if (!currentToken) {
      toast.info("No token is currently on call to hold", {
        position: "top-right",
        closeOnClick: true,
      });
      return;
    }

    setIsLoadingCall(true);
    setPollingEnabled(true);

    try {
      // Use the new HoldTokenStatus API function
      const response = await HoldTokenStatus(currentToken, currentDepPrefix);

      if (response.status === 200) {
        toast.success("Token placed on hold", {
          position: "top-right",
          closeOnClick: true,
        });

        // Clear current token display
        setTokenValue("");
        setDepPrefix("");

        // Update cookies
        Cookies.set("isHoldToken", true);
      } else {
        toast.error("Failed to hold token", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to hold token", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setIsLoadingCall(false);
      refetch();
      setPollingEnabled(false);
    }
  };

  const handleTokenCall = async (
    status,
    counterID,
    depID,
    saveToCookies = false,
  ) => {
    // Early return if already loading
    if (isLoadingCall) return;

    setPollingEnabled(true);
    setIsLoadingCall(true);
 
 
    const newCounterID = counterID || CounterID;
    const newDepID = departmentID || depID;

    try {
      const getCurrentToken = await GetTokenCall(
        newDepID,
        newCounterID,
        status,
        tokenValue,
        depPrefix,
      );

      if (getCurrentToken.status === 200) {
        // Always set cookies on successful call
        const cookiesToSet = {
          DepId: newDepID,
          CounterID: newCounterID,
        };

        if (saveToCookies && allDepartment?.data?.department) {
          const department = allDepartment?.data?.department.find(
            (dept) => dept.DepID === newDepID,
          );
          if (department?.DepPrefix) {
            cookiesToSet.DepPrefix = department.DepPrefix;
          }
        } else if (depPrefix) {
          cookiesToSet.DepPrefix = depPrefix;
        }

        // Set cookies
        Object.entries(cookiesToSet).forEach(([key, value]) => {
          if (value) Cookies.set(key, value.toString(), { path: "/" });
        });

        // FIXED: Create counter object with explicit CounterID
        const counterObject = {
          CounterID: newCounterID,  // Explicitly set CounterID
          CounterName: latestOnCallTokens?.CounterName ||
            counterOnCallToken?.CounterName ||
            "Counter",
          // Don't spread the whole object which might override CounterID
        };

        // FIXED: Log to see what's being saved
        const localStorageData = {
          counter: counterObject,
          DepId: newDepID,
          DepPrefix: cookiesToSet.DepPrefix || depPrefix || "",
        };

        // console.log("Saving to localStorage:", localStorageData);

        localStorage.setItem(
          "CurrentCounter",
          JSON.stringify(localStorageData)
        );

        // Update state immediately
        setCurrentCounterID(newCounterID);

        // Clear state
        setTokenValue("");
        setDepPrefix("");

        // Show success message
        toast.success("Token Called", {
          position: "top-right",
          closeOnClick: true,
        });
      } else {
        throw new Error("Token call failed");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Token call failed", {
        position: "top-right",
        closeOnClick: true,
      });
    } finally {
      setIsLoadingCall(false);
      setOpen(false);
      refetch();
      setPollingEnabled(false);
      console.timeEnd("⏱️ TokenCall Duration");
    }
  };

  const handleHoldTokenCalling = (value) => {
    setTokenValue(value.TokenValue);
    setDepPrefix(value.DepPrefix);
    setDepartmentID(value.DepID);
    setTokenID(value.TokenID);
    setServiceId(value.ServiceID);
    Cookies.set("isHoldToken", true);
    setCurrentCookieDepartmentID(Cookies.get("DepId"));
    // handleClickOpen();
    refetch();
  };

  const handleClickOpen = () => {
    const ChekingTokenValue = parseInt(tokenValue);
    const pendingTokens = pendingvalue?.data?.tokensOnPeding || [];
    const tokenOccurrences = pendingTokens?.filter(
      (token) => token.TokenValue === ChekingTokenValue,
    );
    const cookieDepID = parseInt(Cookies.get("DepId"));
    let currentDepID = parseInt(departmentID);

    if (isNaN(currentDepID)) {
      currentDepID = cookieDepID;
    }
    if (cookieDepID !== currentDepID) {
      setCounterPopUp(true);
    } else {
      setOpen(true);
      refetch();
    }
  };

  const { data: pendingvalue } = useQuery({
    queryKey: ["GetAllPendingToken", selectedServiceId],
    queryFn: () => GetAllPendingToken(selectedServiceId),
    refetchInterval: !pollingEnabled ? 1000 : false,
    enabled: !pollingEnabled,
  });

  const { data: CompletedTokens } = useQuery({
    queryKey: ["GetCompleted", selectedServiceId],
    queryFn: () => GetCompleted(selectedServiceId),
    refetchInterval: !pollingEnabled ? 1000 : false,
    enabled: !pollingEnabled,
  });

  const completeCount = CompletedTokens?.data?.tokensOnCompleted?.filter(
    (token) => {
      if (!selectedServiceId) return true;
      const serviceId = Number(selectedServiceId);
      return token.ServiceID === serviceId;
    },
  )?.length;

  // Token recall
  const pendingCount = pendingvalue?.data?.tokensOnPending?.filter((token) => {
    if (!selectedServiceId) return true;
    const serviceId = Number(selectedServiceId);
    return token.ServiceID === serviceId;
  })?.length;

  /// Token transfer
  const [openTransferToken, setOpenTransferToken] = useState(false);
  const [counterPopUp, setCounterPopUp] = useState(false);

  const hasOnCallToken =
    !!counterOnCallToken?.LastOnCallToken ||
    !!tokenValue ||
    !!latestOnCallTokens?.LastOnCallToken;

  const handleTransferClick = () => {
    setOpen(false);

    // if (!hasOnCallToken) {
    //   toast.info("No token is currently on call to transfer", {
    //     position: "top-right",
    //   });
    //   return;
    // }

    const availableDepartments = allDepartment?.data?.department?.filter(
      (dept) => {
        const DepId = Cookies.get("DepId");
        return Number(DepId) !== dept.DepID;
      },
    );

    if (availableDepartments?.length === 1) {
      handleTransfer(availableDepartments[0].DepID);
    } else {
      setOpenTransferToken(true);
    }
  };

  const handleTimeLineClick = async () => {
    try {
      let tokenId = null;

      if (tokenValue) {
        const checkingTokenValue = parseInt(tokenValue);

        const pendingTokens = pendingvalue?.data?.tokensOnPending || [];
        const foundInPending = pendingTokens?.find(
          (token) =>
            token.TokenValue === checkingTokenValue &&
            token.DepPrefix === depPrefix,
        );

        if (foundInPending) {
          tokenId = foundInPending.TokenID;
        } else {
          // Check in hold tokens
          const holdTokens = holdToken?.data?.tokensOnHold || [];
          const foundInHold = holdTokens?.find(
            (token) =>
              token.TokenValue === checkingTokenValue &&
              token.DepPrefix === depPrefix,
          );

          if (foundInHold) {
            tokenId = foundInHold.TokenID;
          } else {
            // Check if it's the on-call token
            if (
              counterOnCallToken?.LastOnCallToken === parseInt(tokenValue) &&
              counterOnCallToken?.DepPrefix === depPrefix
            ) {
              tokenId = counterOnCallToken?.TokenID;
            } else if (
              latestOnCallTokens?.LastOnCallToken === parseInt(tokenValue) &&
              latestOnCallTokens?.DepPrefix === depPrefix
            ) {
              tokenId = latestOnCallTokens?.TokenID;
            }
          }
        }
      } else {
        // No token entered, use on-call token
        tokenId = latestOnCallTokens?.TokenID || counterOnCallToken?.TokenID;
      }

      // If no token ID found, show error
      if (!tokenId) {
        toast.error("No token selected for timeline", {
          position: "top-right",
        });
        return;
      }

      // Close any open dialogs and show loading
      setOpen(false);
      setShowPopup(true);
      setTimelineLoading(true);

      // Call API with only tokenId
      const response = await GetTimeline(tokenId);

      if (response?.status === 200) {
        setPopupData(response.data);
        setShowPopup(true);
      } else {
        console.error("Error fetching timeline:", response);
        toast.error("Failed to fetch timeline", {
          position: "top-right",
        });
        setShowPopup(false);
      }
    } catch (error) {
      console.error("Error in handleTimeLineClick:", error);
      toast.error("Error fetching timeline", {
        position: "top-right",
      });
      setShowPopup(false);
    } finally {
      setTimelineLoading(false);
    }
  };

  const handleCheckTokenValue = () => {
    setOpenPrefixPopUp(false);
    setCheckPrefix(true);
  };

  const { data: allDepartment } = useQuery({
    queryKey: ["GetDepartments"],
    queryFn: () => GetDepartments(),
    refetchInterval: !pollingEnabled ? 1000 : false,
    enabled: !pollingEnabled,
  });

  // console.log(allDepartment,"allDepartmentlll");
  

  const { data: UserDepartment } = useQuery({
    queryKey: ["GetDepartmentForCoordinator"],
    queryFn: () => GetDepartmentForCoordinator(),
    refetchInterval: !pollingEnabled ? 1000 : false,
    enabled: !pollingEnabled,
  });

  // console.log(UserDepartment?.data?.department, "UserDepartment");

  const handleTransfer = async (departmentId) => {
    const tokenToTransfer = latestOnCallTokens?.LastOnCallToken ?? tokenValue;
    const DepPrefix =
      counterOnCallToken?.DepPrefix ??
      depPrefix ??
      latestOnCallTokens?.DepPrefix;
    const DepId =
      counterOnCallToken?.DepID ?? departmentID ?? latestOnCallTokens?.DepID;
    const tokenId =
      counterOnCallToken?.TokenID ?? tokenID ?? latestOnCallTokens?.TokenID;
    const serviceId =
      counterOnCallToken?.ServiceID || latestOnCallTokens?.ServiceID;

    if (!tokenToTransfer) {
      toast.error("No token is currently on call to transfer.", {
        position: "top-right",
      });
      return;
    }

    try {
      const response = await TokenTransfer(
        tokenToTransfer,
        departmentId,
        serviceId,
        DepPrefix,
        DepId,
        tokenId,
      );

      if (response.status === 200) {
        toast.success("Token Transfer Completed", {
          position: "top-right",
          closeOnClick: true,
          autoClose: 5000,
        });
        GetToken(CounterID);
        setTokenValue("");
        setDepPrefix("");
        setOpenTransferToken(false);
      } else {
        toast.error("Token Transfer Failed", {
          position: "top-right",
        });
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Token Transfer Failed", {
        position: "top-right",
      });
    }
  };

  const handleRecallToken = async () => {
    if (isLoadingCall) return;

    if (!currentCounterToken) {
      toast.info("No token is currently on call for this counter", {
        position: "top-right",
      });
      return;
    }

    setIsLoadingCall(true);
    setPollingEnabled(true);
    try {
      const requestData = {
        tokenId: currentCounterToken.TokenID,
        tokenValue: currentCounterToken.LastOnCallToken || "0",
        serviceId: currentCounterToken.ServiceID || 0,
        DepPrefix: currentCounterToken.DepPrefix,
      };

      const recallTokenResponse = await GetRecallToken(requestData);

      if (recallTokenResponse.status === 200) {
        toast.success("Token Recalled", {
          position: "top-right",
          closeOnClick: true,
        });
      } else {
        toast.error("Token Recall failed", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Token Recall failed", {
        position: toast.POSITION.TOP_RIGHT,
      });
    } finally {
      setIsLoadingCall(false);
      setIsRecallButtonDisabled(true);

      // Start 10-second timer
      setRecallTimer(10);
      const timerInterval = setInterval(() => {
        setRecallTimer((prev) => {
          if (prev <= 1) {
            clearInterval(timerInterval);
            setIsRecallButtonDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      refetch();
      setPollingEnabled(false);
    }
  };

  const holdTokenCount = holdToken?.data?.tokensOnHold?.filter((token) => {
    if (!selectedServiceId) return true;
    const serviceId = Number(selectedServiceId);
    return token.ServiceID === serviceId;
  })?.length;

  return (
    <div className="max-w-[1166px] m-auto select-none px-4 py-5">
      <div className="mb-2">
        <div className="flex items-baseline">
          <span className="text-3xl font-bold mr-2">
            {latestOnCallTokens?.CounterName || "Counter"}
          </span>
          {latestOnCallTokens?.LastOnCallToken != null && (
            <span className="text-3xl font-bold">
              ({latestOnCallTokens?.DepPrefix || ""}
              {latestOnCallTokens?.LastOnCallToken || ""})
            </span>
          )}
        </div>

        {/* Fixed height container for department name */}
        <div className="h-8 flex items-center mt-1 mb-4">
          {counterOnCallToken?.DepName ? (
            <div className="text-small font-normal text-gray-700">
              {counterOnCallToken.DepName}
            </div>
          ) : (
            // Empty placeholder to maintain height when no department
            <div className="text-small font-normal text-gray-700 invisible">
              Placeholder
            </div>
          )}
        </div>
      </div>
      <div className="flex justify-between items-center gap-4 mb-4">
        <div className="flex items-center gap-4">
          {Cookies.get("resetToken") === "true" ? <TokenReset /> : null}
          <div style={{ width: "100px" }}></div>
        </div>

        <div className="flex items-center gap-2 sm:gap-4">
          {localStorage.getItem("NextButton") !== "true" && (
            <div
              className={`w-fit flex justify-center items-center gap-2 sm:gap-3 font-medium rounded-lg text-xs sm:text-sm px-2 sm:px-5 py-1.5 sm:py-2.5 text-center text-white ${allDepartment?.data?.department?.length === 1
                  ? "bg-gray-400 cursor-not-allowed"
                  : hasOnCallToken
                    ? "bg-[#2552EB] hover:bg-[#1a3bb0] cursor-pointer"
                    : "bg-gray-400 cursor-not-allowed"
                }`}
              onClick={() => {
                if (allDepartment?.data?.department?.length === 1) {
                  return;
                }
                if (hasOnCallToken) {
                  handleTransferClick();
                }
              }}
            >
              <img
                className="w-4 sm:w-6"
                src="/image/arrow-goes-left-right-icon.svg"
                alt="transfer"
              />
              <span>Token Transfer</span>
            </div>
          )}
          {/* Timeline Button */}
          <div
            className={`w-fit flex justify-center items-center gap-2 sm:gap-3 font-medium rounded-lg text-xs sm:text-sm px-2 sm:px-5 py-1.5 sm:py-2.5 text-center text-white ${counterOnCallToken?.LastOnCallToken ||
                (tokenValue && tokenValue > 0)
                ? "bg-[#2552EB] hover:bg-[#1a3bb0] cursor-pointer"
                : "bg-gray-400 cursor-not-allowed"
              }`}
            onClick={
              counterOnCallToken?.LastOnCallToken ||
                (tokenValue && tokenValue > 0)
                ? handleTimeLineClick
                : null
            }
          >
            <img
              className="w-3 sm:w-5"
              src="/image/timeline-24.svg"
              alt="timeline"
            />
            <span>Time Line</span>
          </div>
          <div
            className={`w-fit flex justify-center items-center gap-2 sm:gap-3 font-medium rounded-lg text-xs sm:text-sm px-2 sm:px-5 py-1.5 sm:py-2.5 text-center text-white ${(latestOnCallTokens?.LastOnCallToken ||
                counterOnCallToken?.LastOnCallToken) &&
                !isLoadingCall
                ? "bg-[#FF9800] hover:bg-[#F57C00] cursor-pointer"
                : "bg-gray-400 cursor-not-allowed"
              }`}
            onClick={
              (latestOnCallTokens?.LastOnCallToken ||
                counterOnCallToken?.LastOnCallToken) &&
                !isLoadingCall
                ? handleHoldCurrentToken // Direct call, no popup
                : undefined
            }
          >
            {isLoadingCall ? (
              <CircularProgress size={16} sx={{ color: "white" }} />
            ) : (
              <>
                <span>Hold Token</span>
              </>
            )}
          </div>
          {localStorage.getItem("NextButton") !== "true" && (
            <div
              className={`w-fit flex justify-center items-center gap-2 sm:gap-3 font-medium rounded-lg text-xs sm:text-sm px-2 sm:px-5 py-1.5 sm:py-2.5 text-center text-white ${counterOnCallToken?.LastOnCallToken
                  ? "bg-[#2552EB] hover:bg-[#1a3bb0] cursor-pointer"
                  : "bg-gray-400 cursor-not-allowed"
                }`}
              onClick={
                counterOnCallToken?.LastOnCallToken
                  ? handleTokenComplete
                  : undefined
              }
            >
              <span>Complete Token</span>
            </div>
          )}
        </div>

        {Cookies.get("isServiceEnable") === "true" ? (
          <div className="flex-grow max-w-[200px]">
            <label
              htmlFor="service-dropdown"
              className="block text-sm font-medium text-gray-700"
            >
              Select Service
            </label>
            <select
              id="service-dropdown"
              className="w-full p-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:border-[#2552EB]"
              onChange={(e) => {
                const selectedValue = e.target.value;
                setSelectedServiceId(selectedValue);
              }}
            >
              <option value="">All</option>
              {service?.data?.services
                ?.filter((service) => service.SerStatus === true)
                ?.map((service) => (
                  <option key={service.SerID} value={service.SerID}>
                    {service.SerName}
                  </option>
                ))}
            </select>
          </div>
        ) : (
          <div className="w-44"></div>
        )}
      </div>

      {/* token transfer modal */}

      {openTransferToken && (
        <Dialog
          open={openTransferToken}
          onClose={() => setOpenTransferToken(false)}
          aria-labelledby="transfer-dialog-title"
          aria-describedby="transfer-dialog-description"
        >
          <DialogContent>
            <DialogContentText
              id="transfer-dialog-description"
              className="select-none flex justify-between items-center"
            >
              Select a department to transfer the token:
            </DialogContentText>

            <div className="mt-4 flex flex-wrap gap-2 w- max-h-[70vh] overflow-y-auto">
              {allDepartment?.data?.department?.map((dept) => {
                const DepId = Cookies.get("DepId");
                const isCurrentDept = Number(DepId) === dept.DepID;
                return isCurrentDept ? null : (
                  <button
                    key={dept?.DepID}
                    onClick={() => {
                      handleTransfer(dept?.DepID);
                      setOpenTransferToken(false);
                    }}
                    className="mt-4 ml-2 h-11  px-4 py-2 bg-blue-700 text-white font-semibold rounded-lg shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
                  >
                    {dept.DepName}
                  </button>
                );
              })}
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenTransferToken(false)}>Cancel</Button>
          </DialogActions>
        </Dialog>
      )}

      {/* counter call popup */}

      <Dialog
        open={counterPopUp}
        onClose={() => {
          setCounterPopUp(false);
          setShowDepartmentWarning(false);
        }}
        aria-labelledby="counter-dialog-title"
        aria-describedby="counter-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle
          id="counter-dialog-title"
          sx={{
            backgroundColor: showDepartmentWarning ? "#ff9800" : "#2552EB",
            color: "#ffffff",
            padding: "16px 24px",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          {showDepartmentWarning ? (
            <>
              <WarningAmberIcon sx={{ color: "#ffffff" }} />
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Action Required
              </Typography>
            </>
          ) : (
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Select Counter
            </Typography>
          )}
        </DialogTitle>

        <DialogContent sx={{ padding: "24px" }}>
          {showDepartmentWarning ? (
            // Warning message when department mismatch with on-call token
            <div className="flex flex-col items-center justify-center py-8">
              <WarningAmberIcon
                sx={{
                  fontSize: 64,
                  color: "#ff9800",
                  marginBottom: "20px",
                }}
              />
              <Typography
                variant="h6"
                sx={{
                  color: "#333333",
                  textAlign: "center",
                  fontWeight: 600,
                  marginBottom: "12px",
                  fontSize: "1.25rem",
                }}
              >
                Cannot Call Token
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "1rem",
                  color: "#666666",
                  textAlign: "center",
                  maxWidth: "85%",
                  marginBottom: "8px",
                  lineHeight: 1.5,
                }}
              >
                Please transfer or hold the existing on-call token before
                calling a new token from a different department.
              </Typography>
            </div>
          ) : (
            // Normal counter selection
            <>
              <DialogContentText
                id="counter-dialog-description"
                sx={{
                  marginBottom: 2,
                  color: "#555555",
                  fontSize: "1rem",
                }}
              >
                Select a counter for calling the token:
              </DialogContentText>

              <div className="mt-4 flex flex-wrap gap-2 max-h-[70vh] overflow-y-auto">
                {CounterData?.data?.counters?.map((count) => {
                  return (
                    <button
                      key={count.CounterID}
                      onClick={() => {
                        handleTokenCall(0, count.CounterID, count.DepID, true);
                        setCounterPopUp(false);
                      }}
                      className="mt-2 ml-2 h-11 px-4 py-2 bg-blue-700 text-white font-semibold rounded-lg shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75 transition-all duration-200"
                    >
                      {count.CounterName} ({count.DepName})
                    </button>
                  );
                })}
              </div>
            </>
          )}
        </DialogContent>

        <DialogActions sx={{ padding: "16px 24px", justifyContent: "center" }}>
          <Button
            onClick={() => {
              setCounterPopUp(false);
              setShowDepartmentWarning(false);
            }}
            variant={showDepartmentWarning ? "contained" : "text"}
            sx={{
              textTransform: "capitalize",
              padding: showDepartmentWarning ? "8px 32px" : "6px 16px",
              borderRadius: "8px",
              fontWeight: 600,
              ...(showDepartmentWarning && {
                backgroundColor: "#2552EB",
                color: "#ffffff",
                "&:hover": {
                  backgroundColor: "#1a3bb0",
                },
              }),
              ...(!showDepartmentWarning && {
                color: "#2552EB",
              }),
            }}
          >
            {showDepartmentWarning ? "Close" : "Cancel"}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showPopup}
        onClose={() => setShowPopup(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: "16px",
            background: "linear-gradient(145deg, #f5f7fa 0%, #e4e8ed 100%)",
            boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            border: "2px solid #2552EB",
          },
        }}
      >
        <DialogTitle
          sx={{
            bgcolor: "#2552EB",
            color: "white",
            display: "flex",
            alignItems: "center",
            gap: 2,
            py: 2,
            background: "linear-gradient(135deg, #2552EB 0%, #3A6AFF 100%)",
            borderTopLeftRadius: "14px",
            borderTopRightRadius: "14px",
          }}
        >
          <Schedule fontSize="large" sx={{ color: "white" }} />
          <Typography
            variant="h5"
            fontWeight="bold"
            sx={{ textShadow: "0 2px 4px rgba(0,0,0,0.2)" }}
          >
            Token Timeline - {depPrefix || counterOnCallToken?.DepPrefix}
            {tokenValue || counterOnCallToken?.LastOnCallToken}
          </Typography>
        </DialogTitle>

        <DialogContent sx={{ py: 3 }}>
          <Paper
            elevation={0}
            sx={{
              p: 2,
              borderRadius: "12px",
              background: "rgba(255,255,255,0.9)",
              border: "1px solid rgba(37, 82, 235, 0.2)",
              marginTop: "16px",
            }}
          >
            {timelineLoading ? (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: 200,
                }}
              >
                <CircularProgress size={60} />
              </Box>
            ) : popupData?.data?.length > 0 ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                }}
              >
                {popupData.data.map((item, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 3,
                      p: 2,
                      borderRadius: "8px",
                      bgcolor:
                        index % 2 === 0
                          ? "rgba(37, 82, 235, 0.05)"
                          : "transparent",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 4px 12px rgba(37, 82, 235, 0.1)",
                      },
                    }}
                  >
                    {item.TokenStatus === "completed" ? (
                      <CheckCircle
                        sx={{
                          fontSize: 32,
                          color: "#4CAF50",
                          filter:
                            "drop-shadow(0 2px 4px rgba(76, 175, 80, 0.3))",
                        }}
                      />
                    ) : item.TokenStatus === "Generated" ? (
                      <Autorenew
                        sx={{
                          fontSize: 32,
                          color: "#2196F3",
                          filter:
                            "drop-shadow(0 2px 4px rgba(33, 150, 243, 0.3))",
                        }}
                      />
                    ) : (
                      <Pending
                        sx={{
                          fontSize: 32,
                          color: "#FF9800",
                          filter:
                            "drop-shadow(0 2px 4px rgba(255, 152, 0, 0.3))",
                        }}
                      />
                    )}

                    <Box sx={{ flexGrow: 1 }}>
                      <Typography
                        variant="h6"
                        fontWeight="bold"
                        sx={{
                          color:
                            item.TokenStatus === "completed"
                              ? "#4CAF50"
                              : item.TokenStatus === "Generated"
                                ? "#2196F3"
                                : "#FF9800",
                        }}
                      >
                        {item.TokenStatus === "Pending"
                          ? "Generated Time"
                          : item.TokenStatus.charAt(0).toUpperCase() +
                          item.TokenStatus.slice(1)}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          color: "text.secondary",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <AccessTime fontSize="small" />
                        {item.TokenTime}
                        {item.CounterName && (
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 0.5,
                              paddingLeft: "100px",
                            }}
                          >
                            <CountertopsIcon
                              sx={{ fontSize: 16, color: "text.secondary" }}
                            />
                            <Typography
                              variant="body2"
                              sx={{ color: "text.secondary" }}
                            >
                              <strong>Counter:</strong> {item.CounterName}
                            </Typography>
                          </Box>
                        )}
                      </Typography>

                      {/* Additional details section */}
                      <Box
                        sx={{
                          mt: 1,
                          display: "flex",
                          flexDirection: "column",
                          gap: 0.5,
                        }}
                      >
                        {item.DepFromName &&
                          item.DepToName &&
                          item.DepFromName === item.DepToName ? (
                          <Typography
                            variant="body2"
                            sx={{ color: "text.secondary" }}
                          >
                            <strong>Department:</strong> {item.DepFromName}
                          </Typography>
                        ) : (
                          <>
                            {item.DepFromName && (
                              <Typography
                                variant="body2"
                                sx={{ color: "text.secondary" }}
                              >
                                <strong>From:</strong> {item.DepFromName}
                              </Typography>
                            )}
                            {item.DepToName && (
                              <Typography
                                variant="body2"
                                sx={{ color: "text.secondary" }}
                              >
                                <strong>To:</strong> {item.DepToName}
                              </Typography>
                            )}
                          </>
                        )}
                      </Box>
                    </Box>

                    {index < popupData.data.length - 1 && (
                      <Box
                        sx={{
                          height: "40px",
                          width: "2px",
                          bgcolor: "rgba(37, 82, 235, 0.3)",
                          ml: 4,
                          position: "relative",
                          "&::before": {
                            content: '""',
                            position: "absolute",
                            top: "100%",
                            left: "-4px",
                            width: "10px",
                            height: "10px",
                            borderRadius: "50%",
                            bgcolor: "#2552EB",
                            boxShadow: "0 2px 4px rgba(37, 82, 235, 0.3)",
                          },
                        }}
                      />
                    )}
                  </Box>
                ))}
              </Box>
            ) : (
              <Box
                sx={{
                  textAlign: "center",
                  py: 4,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <InfoOutlined
                  sx={{ fontSize: 48, color: "#2552EB", opacity: 0.7 }}
                />
                <Typography variant="body1" sx={{ color: "text.secondary" }}>
                  No timeline data available
                </Typography>
              </Box>
            )}
          </Paper>
        </DialogContent>

        <DialogActions
          sx={{
            px: 3,
            py: 2,
            borderTop: "1px solid rgba(37, 82, 235, 0.1)",
            background: "rgba(37, 82, 235, 0.03)",
          }}
        >
          <Button
            variant="contained"
            onClick={() => setShowPopup(false)}
            sx={{
              borderRadius: "8px",
              px: 4,
              py: 1.5,
              textTransform: "none",
              fontWeight: "bold",
              background: "linear-gradient(135deg, #2552EB 0%, #3A6AFF 100%)",
              boxShadow: "0 4px 8px rgba(37, 82, 235, 0.3)",
              "&:hover": {
                background: "linear-gradient(135deg, #1E45C7 0%, #305AD9 100%)",
                boxShadow: "0 6px 12px rgba(37, 82, 235, 0.4)",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div>
          <div className="flex flex-col justify-between">
            <div className="w-full">
              <h4 className="text-lg">Token No:</h4>
              <span className="text-2xl font-bold">
                {isLoading
                  ? "Loading..."
                  : `${data?.data?.tokenValues?.CallToken ?? 0} of ${data?.data?.tokenValues?.TotalToken ?? 0}`}
              </span>
            </div>
            <input
              className={`text-6xl font-bold h-16 w-full input-no-cursor bg-transparent focus:outline-none focus:outline-0 text-right`}
              value={`${depPrefix}${tokenValue}`}
              readOnly
            />
          </div>
          <div className="grid grid-cols-3 gap-2 mt-2">
            <CounterButton num={"1"} />
            <CounterButton num={"2"} />
            <CounterButton num={"3"} />
            <CounterButton num={"4"} />
            <CounterButton num={"5"} />
            <CounterButton num={"6"} />
            <CounterButton num={"7"} />
            <CounterButton num={"8"} />
            <CounterButton num={"9"} />
            <button
              onClick={() => {
                // const newTokenValue = tokenValue.toString().slice(0, -1);
                // const newDepPrefix = depPrefix.toString().slice(0, -1);
                // setTokenValue(newTokenValue);
                // setDepPrefix(newDepPrefix);
                setTokenValue("");
                setDepPrefix("");
                setDepartmentID("");
                setServiceId("");
                setTokenID("");
              }}
              className="flex items-center justify-center p-4 font-bold shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] w-50 h-50 bg-gray-100 rounded-md text-center leading-50 text-base text-gray-700 m-1"
            >
              <FaBackspace />
            </button>

            <CounterButton num={"0"} />

            {(Number(tokenValue) === currentCounterToken?.LastOnCallToken &&
              depPrefix === currentCounterToken?.DepPrefix) ||
              (currentCounterToken?.LastOnCallToken && !tokenValue) ? (
              <button
                className={`flex items-center justify-center font-bold p-4 rounded-md leading-50 text-base text-center m-1 text-white w-50 h-50 ${isRecallButtonDisabled
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-[#2552EB]"
                  }`}
                onClick={
                  !isRecallButtonDisabled ? handleRecallToken : undefined
                }
                disabled={isRecallButtonDisabled}
              >
                {isRecallButtonDisabled ? "Recalling.." : "Recall"}
                {recallTimer > 0 && recallTimer}
              </button>
            ) : (
              <button
                onClick={() => {
                  if (!isLoadingCall && tokenValue) {
                    const cookieDepID = parseInt(Cookies.get("DepId"));
                    let currentDepID = parseInt(departmentID);
                    if (isNaN(currentDepID)) {
                      currentDepID = cookieDepID;
                    }

                    const hasOnCallToken =
                      counterOnCallToken?.LastOnCallToken ||
                      latestOnCallTokens?.LastOnCallToken;

                    const onCallCounterID =
                      latestOnCallTokens?.CounterID ||
                      counterOnCallToken?.CounterID;

                    const cookieCounterID = parseInt(Cookies.get("CounterID"));
                        console.log(  cookieDepID,"new cookieCounterID");
                        console.log(  currentDepID,"currentDepID");
                        console.log(hasOnCallToken,"hasOnCallToken");
                        
                    // Check if department mismatch
                    if (cookieDepID !== currentDepID) {
                      // If there's an on-call token, show warning message
                      if (hasOnCallToken) {
                        setShowDepartmentWarning(true);
                        setCounterPopUp(true);
                      } else {
                        setShowDepartmentWarning(false);
                        setCounterPopUp(true);
                      }
                    } else {
                      setShowDepartmentWarning(false);
                      if (hasOnCallToken) {
                        if (cookieCounterID === onCallCounterID) {
                          setOpen(true);
                        } else {
                          handleTokenCall(0, CounterID, currentDepID, false);
                        }
                      } else {
                        handleTokenCall(0, CounterID, currentDepID, false);
                      }
                    }
                  }
                }}
                className="flex items-center justify-center p-4 font-bold shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px] bg-gradient-to-b from-[#358000] to-[#80C259]
                 w-50 h-50 bg-gray-100 rounded-md text-center leading-50 text-white text-gray-700 m-1"
                disabled={isLoadingCall}
              >
                {isLoadingCall ? "Calling..." : "CALL"}{" "}
                {/* {localStorage.getItem("NextButton") === "true" &&
                  data?.data?.tokenValues?.NextToken !== "0" &&
                  ` : ${data?.data?.tokenValues?.NextToken}`} */}
              </button>
            )}
          </div>
          <div className="grid grid-cols-2 gap-2 mt-4">
            <div
              onClick={() => {
                if (
                  !isLoadingCall &&
                  pendingCount > 0 &&
                  counterOnCallToken !== undefined
                ) {
                  handleTokenCall(1);
                }
              }}
              className={`bg-gradient-to-b from-[#2552EB] to-[#3C73F6] hover:from-[#3C73F6] hover:to-[#2552EB] transform-colors duration-300 flex flex-col items-center justify-center p-5 cursor-pointer w-full text-white text-lg gap-2 ${isLoadingCall ||
                  (pendingCount === 0 && counterOnCallToken == undefined)
                  ? "opacity-50 cursor-not-allowed"
                  : ""
                }`}
            // disabled={isLoadingCall || pendingCount === 0 && counterOnCallToken != undefined}
            >
              <img className="w-9" src="/image/element_1.svg" alt="element" />
              {isLoadingCall ? "Calling" : "Hold & Next"}
            </div>

            {localStorage.getItem("NextButton") === "true" ? (
              <div
                className={`w-full flex flex-col items-center justify-center p-5 cursor-pointer bg-gradient-to-b from-[#2552EB] to-[#3A6AFF] text-white text-lg gap-2 ${allDepartment?.data?.department?.length === 1
                    ? "opacity-50 cursor-not-allowed"
                    : hasOnCallToken
                      ? "hover:from-[#1a3bb0] hover:to-[#2A4AC0]"
                      : "opacity-50 cursor-not-allowed"
                  }`}
                onClick={() => {
                  if (allDepartment?.data?.department?.length === 1) {
                    return;
                  }
                  if (hasOnCallToken) {
                    handleTransferClick();
                  }
                }}
              >
                <div className="flex items-center gap-2">
                  <img
                    className="w-9"
                    src="/image/arrow-goes-left-right-icon.svg"
                    alt="transfer"
                  />
                </div>
                <span>Token Transfer</span>
              </div>
            ) : (
              // Show Next Token button when NextButton is false
              <div
                onClick={() => {
                  const cookieDepID = parseInt(Cookies.get("DepId"));
                  let currentDepID = parseInt(departmentID);

                  if (isNaN(currentDepID)) {
                    currentDepID = cookieDepID;
                  }

                  const hasOnCallToken =
                    counterOnCallToken?.LastOnCallToken ||
                    latestOnCallTokens?.LastOnCallToken;

                  if (cookieDepID !== currentDepID) {
                    if (hasOnCallToken) {
                      setShowDepartmentWarning(true);
                      setCounterPopUp(true);
                    } else {
                      setShowDepartmentWarning(false);
                      setCounterPopUp(true);
                    }
                  } else {
                    setShowDepartmentWarning(false);
                    if (!isLoadingCall && pendingCount > 0) {
                      handleTokenCall(0);
                    } else {
                      setOpen(true);
                    }
                  }
                }}
                className={`flex flex-col items-center justify-center p-5 cursor-pointer bg-gradient-to-b from-[#358000] to-[#80C259] w-full text-white text-lg gap-2 ${isLoadingCall ||
                    pendingCount === 0 ||
                    data?.data?.NextToken === "0"
                    ? "opacity-50 cursor-not-allowed pointer-events-none"
                    : ""
                  }`}
                disabled={
                  isLoadingCall ||
                  pendingCount === 0 ||
                  data?.data?.tokenValues?.NextToken === "0"
                }
              >
                <div className="flex items-center gap-2">
                  <img
                    className="w-9"
                    src="/image/element_2.svg"
                    alt="element"
                  />
                </div>
                {isLoadingCall ? "Calling" : "Next Token"}{" "}
                {data?.data?.tokenValues?.NextToken !== "0" &&
                  ` : ${data?.data?.tokenValues?.NextToken}`}
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-col">
          <div className="flex justify-between">
            <div
              onClick={() => {
                setHoldMenu(true);
                setCompletedMenu(false);
              }}
              className={`${holdMenu && !completedMenu ? "bg-[#2552EB]" : "bg-gray-400"
                } cursor-pointer transition-all duration-300 flex justify-center gap-2 text-center w-full text-white p-4 rounded-tl-3xl text-1xl uppercase font-bold`}
            >
              <Badge
                badgeContent={holdTokenCount}
                color="secondary"
                className="m-2"
              >
                <img
                  className="w-11"
                  src="/image/element_1.svg"
                  alt="element"
                />
              </Badge>
              Token on hold
            </div>
            <div
              onClick={() => {
                setHoldMenu(false);
                setCompletedMenu(false);
              }}
              className={`${!holdMenu && !completedMenu ? "bg-[#2552EB]" : "bg-gray-400"
                } cursor-pointer transition-all duration-300 flex justify-center gap-2 text-center w-full text-white p-4 text-1xl uppercase font-bold`}
            >
              <Badge
                badgeContent={pendingCount}
                color="secondary"
                className="m-2"
              >
                <img
                  className="w-11"
                  src="/image/element_1.svg"
                  alt="element"
                />
              </Badge>
              Pending Token
            </div>
            <div
              onClick={() => {
                setHoldMenu(false);
                setCompletedMenu(true);
              }}
              className={`${completedMenu ? "bg-[#34b450]" : "bg-gray-400"
                } cursor-pointer transition-all duration-300 flex justify-center gap-2 text-center w-full text-white p-4 rounded-tr-3xl text-1xl uppercase font-bold`}
            >
              <Badge
                color="secondary"
                className="m-2"
                badgeContent={completeCount}
              >
                <img
                  className="w-11"
                  src="/image/token-svgrepo-com.svg"
                  alt="element"
                />
              </Badge>
              Completed Token
            </div>
          </div>

          {holdMenu && !completedMenu ? (
            <Paper className="flex" sx={{ width: "100%" }}>
              <TableContainer sx={{ maxHeight: 440 }} className="flex">
                <Table>
                  <TableBody>
                    {evenTokens?.map((evenTokens, index) => (
                      <TableRow key={`even-${index}`}>
                        <TableCell
                          style={{
                            textAlign: "center",
                            fontSize: "25px",
                            fontWeight: "bold",
                            verticalAlign: "top",
                            borderRightWidth: "1px",
                          }}
                          onClick={() => handleHoldTokenCalling(evenTokens)}
                        >
                          <div>
                            {`${evenTokens?.DepPrefix || Cookies.get("DepPrefix")
                              }${evenTokens.TokenValue}`}
                            {Cookies.get("isServiceEnable") === "true" && (
                              <div
                                style={{
                                  fontSize: "15px",
                                  fontWeight: "normal",
                                }}
                              >
                                {evenTokens?.ServiceName || ""}
                              </div>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                <Table>
                  <TableBody>
                    {oddTokens?.map((oddTokens, index) => (
                      <TableRow key={`odd-${index}`}>
                        <TableCell
                          style={{
                            textAlign: "center",
                            fontSize: "25px",
                            fontWeight: "bold",
                            verticalAlign: "top",
                            borderLeftWidth: "1px",
                          }}
                          onClick={() => handleHoldTokenCalling(oddTokens)}
                        >
                          <div>
                            {`${oddTokens?.DepPrefix || Cookies.get("DepPrefix")
                              }${oddTokens.TokenValue}`}
                            {Cookies.get("isServiceEnable") === "true" && (
                              <div
                                style={{
                                  fontSize: "15px",
                                  fontWeight: "normal",
                                }}
                              >
                                {oddTokens?.ServiceName || ""}
                              </div>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          ) : completedMenu ? (
            <CompletedToken
              pendingValue={(e) => {
                setTokenValue(e.val);
                setDepPrefix(e.prefix);
              }}
              data={CompletedTokens}
              selectedServiceId={selectedServiceId}
            />
          ) : (
            <PendingToken
              pendingValue={(e) => {
                setTokenValue(e.val);
                setDepPrefix(e.prefix);
                setDepartmentID(e.DepId);
                setServiceId(e.ServiceID);
                setTokenID(e.TokenID);
              }}
              data={pendingvalue}
              selectedServiceId={selectedServiceId}
            />
          )}
        </div>
      </div>

      <TokenCall
        open={open}
        opens={openPrefixPopUp}
        setOpen={setOpen}
        handleTokenCall={handleTokenCall}
        isLoadingCall={isLoadingCall}
        handleTokenComplete={handleTokenComplete}
        tokenValue={counterOnCallToken?.LastOnCallToken}
        checkLastCallCount={counterOnCallToken}
      />
    </div>
  );
};
export default Counter;
